import { connect, MapDispatchToProps } from 'react-redux';
import { Props } from './NetworkBarGroupLink';
import { togglePinGroup, unrecommendGroup } from '../../redux/actions';

export type DispatchProps = Pick<Props, 'togglePinGroup' | 'unrecommendGroup'>;
export type OwnProps = Omit<Props, keyof DispatchProps>;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  togglePinGroup,
  unrecommendGroup,
};

export default connect(null, mapDispatchToProps);
